module.exports = __webpack_public_path__ + "static/media/smart-details.b86538f9.jpg";